import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const MatchPaymentSchema = withDefaults({
  type: 'match-payment',
  fields: [
    {
      kind: 'attribute',
      name: 'transactionAmount',
    },
    {
      kind: 'attribute',
      name: 'transactionDate',
    },
    {
      kind: 'attribute',
      name: 'qualificationState',
    },
    {
      kind: 'attribute',
      name: 'transitionLog',
    },
    {
      kind: 'attribute',
      name: 'certified',
    },
    {
      kind: 'attribute',
      name: 'paymentCertifiedAt',
    },
    {
      kind: 'attribute',
      name: 'qualificationErrors',
    },
    {
      kind: 'attribute',
      name: 'discardedAt',
    },
    {
      kind: 'belongsTo',
      name: 'matchParticipant',
      type: 'match-participant',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'accountTransaction',
      type: 'account-transaction',
      options: {
        async: false,
        inverse: 'matchPayments',
      },
    },
    {
      kind: 'belongsTo',
      name: 'account',
      type: 'account',
      options: {
        async: false,
        inverse: 'match-payment',
      },
    },
    {
      kind: 'belongsTo',
      name: 'matchPeriod',
      type: 'match-period',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default MatchPaymentSchema;
